import { useState } from "react";
import MaskEditor from "./MaskEditor";
import TextLayerEditor from "./TextLayerEditor";

const ImageEditorView = () => {

  const [showMask, setShowMask] = useState(false);

  return (
    <div className="mt-[5vh] w-full h-[95vh] p-5 md:p-7 md:pt-4 2xl:p-14 overflow-auto flex flex-col gap-4 xl:gap-8 ">
      {showMask ?
        <MaskEditor setShowMask={setShowMask} /> 
        : <TextLayerEditor />
      }
    </div>

  )
}

export default ImageEditorView;
